export const DEFAULR_INDENT_PER_LEVEL = 24;

export const DEFAULT_ITEM_TYPE = 'tree-item';
